// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"0487287d","668":"cc5f476c","838":"bc34ca2b"}[chunkId] + ".js";
};